// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"91":"b2bc8787","677":"5dc88aa7"}[chunkId] + ".chunk.js");